import { fetchWrapper } from "_helpers";
import { toast, Slide } from "react-toastify";

export const getUserList = async ({
  page,
  pageSize,
  sortField,
  sortOrder,
  searchQuery,
  filters,
}) => {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;
  try {
    let apiUrl = baseUrl + `/admin/getUserList?page=${page}&size=${pageSize}`;
    apiUrl += sortField?.length ? `&sort=${sortField}&order=${sortOrder}` : "";
    apiUrl += searchQuery.length ? `&search=${searchQuery}` : "";
    apiUrl += filters?.userIds?.length
      ? filters.userIds.map((id) => `&userIds[]=${id}`).join("")
      : "";
    let data = await fetchWrapper.get(apiUrl);
    return data;
  } catch (error) {
    console.error("err  ", error);
    toast.error(
      <div>
        ❗ {error}
      </div>,
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      }
    );
    return { data: { totalItems: 0, rows: [] }, error };
  }
};

export const exportUserList = async ({
  sortField = "",
  sortOrder = "",
  searchQuery = "",
  filters = {},
  userIds = [],
}) => {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;
  try {
    let apiUrl = baseUrl + `/admin/getUserList?isExporting=true`;
    apiUrl += sortField?.length ? `&sort=${sortField}&order=${sortOrder}` : "";
    apiUrl += searchQuery.length ? `&search=${searchQuery}` : "";
    apiUrl += filters?.userIds?.length
      ? filters.userIds.map((id) => `&userIds[]=${id}`).join("")
      : "";
    apiUrl += userIds?.length
      ? userIds.map((id) => `&userIds[]=${id}`).join("")
      : "";
    const response = await fetchWrapper.get(apiUrl);
    const blob = await response.blob();
    const baseName = "USER_LIST_";
    const now = new Date();
    const formattedDate = now.toISOString().split("T")[0]; // YYYY-MM-DD format
    const formattedTime = now.toTimeString().split(" ")[0].replace(/:/g, "_"); // HH_MM_SS format
    const urlXls = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = urlXls;
    a.download = `${baseName}_${formattedDate} ${formattedTime}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    await window.URL.revokeObjectURL(urlXls);
    toast(<div>Downloaded Sucessfully!</div>, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Slide,
    });
    return response;
  } catch (error) {
    console.error("err  ", error);
    toast.error(
      <div>
        ❗ Something went wrong!
        <br /> Please try again later.
      </div>,
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      }
    );
    return { data: { totalItems: 0, rows: [] }, error };
  }
};

export const getALLRolesList = async () => {
    const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;
    try {
      let apiUrl = baseUrl + `/common/allRoles`;
      let data = await fetchWrapper.get(apiUrl);
      return data;
    } catch (error) {
      console.error("err  ", error);
      toast.error(
        <div>
          ❗ Something went wrong!
          <br /> Please try again later.
        </div>,
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        }
      );
      return { data: { }, error };
    }
  };

export const getUserDetails = async (userId, adminAccess) => {
    const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;
    try {
      let apiUrl = adminAccess ? baseUrl + `/admin/getUserDetails/${userId}` : baseUrl + `/common/getUserDetails`;
      let data = await fetchWrapper.get(apiUrl);
      return data;
    } catch (error) {
      console.error("err  ", error);
      toast.error(
        <div>
          ❗ Something went wrong!
          <br /> Please try again later.
        </div>,
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        }
      );
      return { data: { }, error };
    }
  };

export const registerUser = async (payload) => {
    const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;
    try {
      let apiUrl = baseUrl + `/admin/registerUser`;
      let resp = await fetchWrapper.post(apiUrl,payload);
      return resp;
    } catch (error) {
      toast.error(
        <div>
          ❗ {error}
        </div>,
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        }
      );
      return { data: { }, error };
    }
  };

export const checkUniqueUsername = async (payload) => {
    const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}`;
    try {
      let apiUrl = baseUrl + `/admin/checkUniqueUsername`;
      let resp = await fetchWrapper.post(apiUrl,payload);
      return resp;
    } catch (error) {
      toast.error(
        <div>
          ❗ {error}
        </div>,
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        }
      );
      return { data: { }, error };
    }
  };



  